import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { SoakingStatusWiseResponseDto } from "./soaking-status-wise-response.dto";

export class SoakingStatusWiseResponseModel extends GlobalResponseObject{
    data?: SoakingStatusWiseResponseDto;
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data string
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: SoakingStatusWiseResponseDto) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}